import styled from 'styled-components';

import { ButtonDefault } from '../buttonDefault/style';

export const ButtonWithIconStyle = styled(ButtonDefault)(({children, onClick, ...props}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  padding: '10px 16px',
  borderRadius: 6,
  '& > button': {
    margin: '4px',
    cursor: 'pointer',
  },
  ...props,
}));
